<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <PositionResultComponent option="payment"/>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import PositionResultComponent from './PositionResultComponent.vue'

export default {
  name: 'home',
  data: function () {
    return {
      isLoading: false

    }
  },
  components: {
    PositionResultComponent

  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">
  .summary-wrap{
    margin-bottom: 20px;
  }
</style>
